import { LatLngExpression } from "leaflet";
import { useMemo } from "react";

export function useLatLngExpr(lat: number, lng: number) {
  return useMemo<LatLngExpression>(() => ({ lat, lng }), [lat, lng]);
}
